import { useTranslation } from '@klv/hooks/useTranslation';
import useIsHydrated from '@klv/hooks/useIsHydrated';

import { UniversalMenuItem } from '@klv/molecules/universal-menu-item';
import { useAuthentication } from '@klv/context/authentication';
import { generateClassName } from '@klv/shared/utils/functions';
import { savePreferredLocale } from './utils';

import * as styles from './styles/accountLogIn.module.css';

import type { IAccountLogIn } from './types';

export const AccountLogIn = ({
  className = '',
  ...props
}: IAccountLogIn) => {
  const { i18n, t } = useTranslation();
  const isHydrated = useIsHydrated();
  const { authenticationState } = useAuthentication();
  const {
    landingPageUrl = t('navigation_platformActions_account_href'),
    loggedIn,
  } = authenticationState;

  const showAccountLoggedIn = isHydrated && loggedIn;

  return (
    <UniversalMenuItem
      {...props}
      className={generateClassName([className, styles.accountLogIn])}
      href={showAccountLoggedIn ? landingPageUrl : t('navigation_platformActions_logIn_href')}
      label={showAccountLoggedIn ? t('navigation_platformActions_account_label') : t('navigation_platformActions_logIn_label')}
      onClick={() => {
        savePreferredLocale({ locale: i18n.language });
      }}
    />
  );
};
